import React, { useState, useEffect, useContext } from 'react';
import './DashboardTimeFilter.css';
import moment from 'moment';
import { getUserType } from '../../common/utils/cookie-utils';
import { StateExporter } from '../../containers/CMDashboard/CMDashboard';
import { StateExporterRm } from '../../containers/RMDashboard/RmDashboard';
import { StateExporterPtn } from '../../containers/PartnerDashboard/PartnerDashboard';
import { StateExporterCallDetails } from '../../containers/CallDetails/CallDetails';
import { StateExporterBp } from '../../containers/AdminDashboard/AdminDashboard';
import { getAcl } from '../../common/utils/acl-utils';

const DashboardTimeFilter = ({ lastMonth, user }) => {
  const [activeDiv, setActiveDiv] = useState(1);
  const stateImporter = useContext(StateExporter);
  const stateExporterRm = useContext(StateExporterRm);
  const stateExporterPtn = useContext(StateExporterPtn);
  const stateExporterCallDetails = useContext(StateExporterCallDetails);
  const stateExporterBp = useContext(StateExporterBp);

  let userType = getUserType();
  if (stateExporterCallDetails && stateExporterCallDetails?.CallDetails)
    userType = 3; // for callDetails container
  if (stateExporterBp && stateExporterBp?.bp) userType = 4; //for bp

  const contextTypeDecider = () => {
    switch (parseInt(userType)) {
      case 0:
        return stateExporterPtn;
      case 1:
        if (user == 'rm') return stateImporter;
        else return stateExporterRm;

      case 2:
        return stateImporter;
      case 3:
        return stateExporterCallDetails;
      case 4:
        return stateExporterBp;
      default:
        return null;
    }
  };
  const { startDate, endDate, setStartDate, setEndDate } =
    contextTypeDecider() || {};

  useEffect(() => {
    if (
      startDate === moment().format('YYYY-MM-DD') &&
      endDate === moment().format('YYYY-MM-DD')
    )
      setActiveDiv(1);
    else if (
      startDate ===
        moment()
          .subtract(6, 'd')
          .format('YYYY-MM-DD') &&
      endDate === moment().format('YYYY-MM-DD')
    )
      setActiveDiv(2);
    else if (
      startDate ===
        moment()
          .startOf('month')
          .format('YYYY-MM-DD') &&
      endDate === moment().format('YYYY-MM-DD')
    )
      setActiveDiv(3);
    else if (
      startDate ===
        moment()
          .subtract(1, 'months')
          .startOf('month')
          .format('YYYY-MM-DD') &&
      endDate ===
        moment()
          .subtract(1, 'months')
          .endOf('month')
          .format('YYYY-MM-DD')
    )
      setActiveDiv(4);
    else setActiveDiv('');
  }, [startDate, endDate]);

  const oneWeekDateSetter = () => {
    setEndDate(moment().format('YYYY-MM-DD'));
    setStartDate(
      moment()
        .subtract(6, 'd')
        .format('YYYY-MM-DD')
    );
  };
  const thisMonthTimeSetter = () => {
    setStartDate(
      moment()
        .startOf('month')
        .format('YYYY-MM-DD')
    );
    setEndDate(moment().format('YYYY-MM-DD'));
  };
  const lastMonthTimeSetter = () => {
    setStartDate(
      moment()
        .subtract(1, 'months')
        .startOf('month')
        .format('YYYY-MM-DD')
    );
    setEndDate(
      moment()
        .subtract(1, 'months')
        .endOf('month')
        .format('YYYY-MM-DD')
    );
  };
  return (
    <>
      <div className="timeLineParent flex flex-row rounded bg-white cursor-pointer ">
        <div
          onClick={() => {
            setActiveDiv(1);
            setStartDate(moment().format('YYYY-MM-DD'));
            setEndDate(moment().format('YYYY-MM-DD'));
          }}
          className={
            (activeDiv == 1 ? 'btnActive text-white ' : 'text-grey-995') +
            ' flex-shrink-0 px-6 py-2 rounded-l font-roboto text-sm font-light '
          }
        >
          <p>Today</p>
        </div>
        <div
          onClick={() => {
            setActiveDiv(2);
            oneWeekDateSetter();
          }}
          className={
            (activeDiv == 2 ? 'btnActive text-white ' : 'text-grey-995') +
            ' flex-shrink-0 middle  px-6  py-2  font-roboto text-left text-sm font-light'
          }
        >
          <p>1 week</p>
        </div>
        <div
          onClick={() => {
            setActiveDiv(3);
            thisMonthTimeSetter();
          }}
          className={
            (activeDiv == 3 ? 'btnActive text-white ' : 'text-grey-995') +
            (!lastMonth ? ' rounded-r ' : '') +
            ' flex-shrink-0 px-6 py-2  font-roboto text-sm font-light'
          }
        >
          <p>This Month</p>
        </div>
        {lastMonth === true ? (
          <div
            onClick={() => {
              setActiveDiv(4);
              lastMonthTimeSetter();
            }}
            className={
              (activeDiv == 4 ? 'btnActive text-white ' : 'text-grey-995') +
              ' flex-shrink-0 border-l border-grey-990 px-6 py-2 rounded-r font-roboto text-sm font-light'
            }
          >
            <p>Last Month</p>
          </div>
        ) : null}
      </div>
    </>
  );
};

export default DashboardTimeFilter;
